import { render, staticRenderFns } from "./client-nav.vue?vue&type=template&id=48412f20&"
import script from "./client-nav.vue?vue&type=script&lang=js&"
export * from "./client-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports